import { useMemo } from 'react';

import { getFilterOptions } from '../../../helpers/filter';

export const useFilterOptions = data => {
  return useMemo(() => {
    if (!Array.isArray(data) || data.length === 0) {
      return {
        farms: [],
        farmIds: [],
        types: []
      };
    }

    const farmIds = Array.from(
      new Set(data.map(({ farm_id }) => farm_id))
    ).map(farmId => ({
      value: farmId,
      text: farmId,
    }));

    return {
      farms: getFilterOptions(data, 'farm', 'name'),
      farmIds,
      types: getFilterOptions(data, 'main_type')
    };
  }, [data]);
};
